<template>
	<div id="home">
		<hero/>
		<numbers 		:pdfLink="pdfLink.number"/>
		<ceo 			:pdfLink="pdfLink.ceo"/>
		<investering 	:pdfLink="pdfLink.investering"/>
		<kunden 		:pdfLink="pdfLink.kunden"/>
		<samhallet 		:pdfLink="pdfLink.samhallet"/>
		<hallbart 		:pdfLink="pdfLink.hallbart"/>
	</div>
</template>
<script>
	import Hero 		from '@/sections/Hero.vue'
	import Numbers 		from '@/sections/Number.vue'
	import Ceo 			from '@/sections/Ceo.vue'
	import Investering 	from '@/sections/Investering.vue'
	import Kunden 		from '@/sections/Kunden.vue'
	import Samhallet 	from '@/sections/Samhallet.vue'
	import Hallbart 	from '@/sections/Hallbart.vue'
	export default {
		name: 'Home',
		metaInfo: {
			title: 'JM',
			titleTemplate: null,
			meta: [
				{ vmid: 'description', name: 'description', content: 'JM' }
			]
		},
		props: {
			pdfLink: {
				type: Object,
				default: null
			}
		},
		components: {
			Hero,
			Numbers,
			Ceo,
			Investering,
			Kunden,
			Samhallet,
			Hallbart
		}
	}
</script>
